module.exports = __webpack_public_path__ + "img/F3b.6eb8efa0.svg";